import { classNames, Component, h, tag } from "omi";

import { BoxStatus } from "@/components/validations/models.ts";
import { IconName, NWIcon } from "@/components/atoms";
import { tailwind } from "@/tailwind";

type Direction = "left" | "right";

export type Props = {
  direction: Direction;
  disabled?: boolean;
  status?: BoxStatus;
};

@tag("nw-carousel-arrow")
export class NWCarouselArrow extends Component<Props> {
  static css = [tailwind];

  static propTypes = {
    direction: String,
    disabled: Boolean,
    onClick: Function,
    status: String,
  };

  private getIconNameForDirection(direction: Direction): IconName {
    return direction === "right" ? "arrow-right" : "arrow-left";
  }

  render({ status = BoxStatus.INCOMPLETE, disabled = false }: Props) {
    return (
      <button
        disabled={disabled}
        class={classNames(
          "w-fit outline-none focus-visible:shadow-ring-sxs hover:backdrop-blur-sm h-fit rounded-full transition-colors disabled:text-gray-300 cursor-pointer border border-gray-300 disabled:border-gray-100 p-3.5 disabled:bg-white hover:bg-secondary hover:text-primary disabled:cursor-not-allowed",
          {
            "hover:bg-success-100 hover:border-success-500 hover:text-success-500": status === BoxStatus.COMPLETE,
          },
          { "hover:bg-success-100 hover:border-success-500 hover:text-success-500": status === BoxStatus.REVIEW },
        )}
      >
        <NWIcon name={this.getIconNameForDirection(this.props.direction)} width={24} height={24} />
      </button>
    );
  }
}
